import type { InfiniteData, QueryKey } from '@tanstack/query-core'
import queryClient from './queryClient'

export function prepareToRefetchListQuery<TData>(queryKey: QueryKey) {
	queryClient.setQueryData(queryKey, (prev: InfiniteData<TData>) => ({
		pages: prev?.pages.slice(0, 1) ?? [],
		pageParams: prev?.pageParams.slice(0, 1) ?? [],
	}))
}
